import React from "react";
import { useTranslation } from "react-i18next";
import Hannes from "../../assets/images/hannes.jpg";
import Vicka from "../../assets/images/victoria.jpg";

export const HomeAboutSection = ({ onImageLoad }) => {
  const { t } = useTranslation();

  return (
    <section className="about-section">
      <h1>{t("home.about_section.title")}</h1>
      <div className="about-container">
        <div>
          <img
            src={Vicka}
            onLoad={onImageLoad}
            alt="Vicka"
            className="about-image"
          />
          <p className="about-text">{t("home.about_section.vicka")}</p>
        </div>
        <div>
          <img
            src={Hannes}
            onLoad={onImageLoad}
            alt="Hannes"
            className="about-image"
          />
          <p className="about-text">{t("home.about_section.hannes")}</p>
        </div>
      </div>
    </section>
  );
};
